import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {ReportComponentSummaryModel} from './reportComponentSummary.model';
import {FormModel} from '../../../../form/form/api/entity/form.model';

export class ReportComponentModel extends WithSummaryModel<ReportComponentSummaryModel> {
    parametersForm: FormModel;
    widthPct: number;
}
